<div>
  <mat-grid-list [cols]="1">
    <div class="center-column">
      <huge-row class="mat-padding">
        <mat-col>
          <img src="assets/img/hugeconnect.png" alt="logo" class="hugeLogo" />
        </mat-col>
      </huge-row>
      <div class="card wrapper center-column">
        <huge-row>
          <mat-col class="text-align-center">
            <p class="identity-card-title"> Reset Password </p>
          </mat-col>
        </huge-row>
        <huge-row>
          <mat-col class="text-align-center">
            <p class="identity-card-subtitle vertical-margin"> User key verified, please type in your new password </p>
          </mat-col>
        </huge-row>
        <form [formGroup]="formGroup">
          <mat-form-field class="form-field-width">
            <mat-label position="floating">Password</mat-label>
            <input matInput formControlName="passwordControl" [type]="'password'" (keyup.enter)="resetPassword()"
              required />
            @if (formGroup.get('passwordControl')!.hasError('required')) {
            <mat-error>
              Password is required.
            </mat-error>
            }@else if( formGroup.get('passwordControl')!.hasError('minlength')) {
            <mat-error>
              Password must be at least 8 characters long.
            </mat-error>
            }

          </mat-form-field>


          <mat-form-field class="form-field-width">
            <mat-label>Confirm Password</mat-label>
            <input matInput formControlName="confirmPasswordControl" type="password" [type]="'password'"
              (keyup.enter)="resetPassword()" required />
            @if (formGroup.get('confirmPasswordControl')!.hasError('required')) {
            <mat-error>
              Confirm password is required.
            </mat-error>
            }@else if (formGroup.get('confirmPasswordControl')!.hasError('passwordsMismatch')) {
            <mat-error>
              Passwords do not match.
            </mat-error>
            }
          </mat-form-field>
        </form>

        <huge-row class="mat-margin-top mat-justify-content-center">
          <mat-col>
            <button class="btn primary-btn" expand="full" (click)="resetPassword()">SAVE</button>
          </mat-col>
        </huge-row>
        <huge-row>
          <mat-col>
            <p class="close-modal-text" (click)="cancel()">Go back</p>
          </mat-col>
        </huge-row>
      </div>
    </div>
  </mat-grid-list>
</div>